import {
    Autoplay,
    Controller,
    EffectCreative,
    EffectFade,
    FreeMode,
    Mousewheel,
    Navigation,
    Pagination,
    Scrollbar,
    Thumbs
} from 'swiper/modules';
import type {ISwiperSlider, ISwiperSliderOptions} from '@/components/swiper-slider/types';
import Swiper from 'swiper';

const modules =
    [Controller, EffectCreative, EffectFade, Navigation, Pagination, Thumbs, Autoplay, Mousewheel, FreeMode, Scrollbar];

Swiper.use(modules);

class SwiperSlider implements ISwiperSlider {
    private readonly item: HTMLElement | null;
    private readonly settings: Record<string, string | number>;
    private slider: Swiper | null;

    constructor(options: ISwiperSliderOptions) {
        this.item = options.item;
        this.slider = null;
        this.settings = options.settings;
    }

    public get getSlider(): Swiper {
        return this.slider;
    }

    init(): Swiper {
        this.slider = new Swiper(this.item, this.settings);

        return this.slider;
    }

    destroy(): void {
        if (!this.slider) {
            return;
        }

        this.slider.destroy();
        this.slider = null;
    }
}

export default SwiperSlider;
